module.exports = __webpack_public_path__ + "img/buy-icon4-en.5bba33b.png";